import React from 'react'
import { Row, Select } from 'antd'
import { useTranslation } from 'next-i18next'
import { loadContributionUnitsArray } from 'src/core/json'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomCol, FormLabels, CustomSelect } from 'src/components'
import { projectFormIsActiveSelector, setProjectFormItemValue } from 'src/features'
const { Option } = Select

const ProjectContributionUnitSelector: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const isActive = useAppSelector(projectFormIsActiveSelector)
  const contributionUnitList = loadContributionUnitsArray()

  return (
    <Row>
      <CustomCol>
        <FormLabels
          title={t('Projects.ContributionUnit')}
          subtitle={t('Projects.ContributionUnitLabel')}
        />
      </CustomCol>
      <CustomCol>
        <CustomSelect
          name='contribution_unit'
          placeholder={t('Projects.ContributionUnitPlaceholder')}
          onChange={(value: string) => dispatch(setProjectFormItemValue({ key: 'contribution_unit', value }))}
          required={isActive}
        >
          {contributionUnitList.map((unit: string, idx: number) => <Option value={unit} key={idx}>{unit}</Option>)}
        </CustomSelect>
      </CustomCol>
    </Row>
  )
}

export default ProjectContributionUnitSelector
